export const routesPlaka = [
  {
    path: "/plaka",
    name: "plaka",
    component: () => import("@/views/plaka/index.vue"),
    meta: {
      requiresAuth: true,
      layout: "default",
      yetki: { k: [], a: true },
    },
  },
]
